import { render, staticRenderFns } from "./ProfileTalentAvailabilityOpportunityItem.vue?vue&type=template&id=289b594b"
import script from "./ProfileTalentAvailabilityOpportunityItem.vue?vue&type=script&lang=js"
export * from "./ProfileTalentAvailabilityOpportunityItem.vue?vue&type=script&lang=js"
import style0 from "./ProfileTalentAvailabilityOpportunityItem.vue?vue&type=style&index=0&id=289b594b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports